<template>
  <div class="orderdonev2">
    <div class="container">
      <!-- Content here -->
      <br />

      <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <a class="navbar-brand" href="#">我們收到委託單了</a>
      </nav>

      <br />
      <div class="card">
        <div class="card-body">
          <h5>我們確認收到委託單了!</h5>
          <br />
          <h5>我們可以回到聊天室繼續操作了!</h5>

          <!-- <router-link to="/store">
            <button type="button" class="btn btn-primary btn-block">
              回到商品列
            </button>
          </router-link>-->
        </div>
      </div>
      <br />
      <div class="card">
        <div class="card-body">
          <p>你可能也會想批這些:</p>
          <div
            v-for="(recommends_info, recommends_index) in recommends"
            v-bind:key="(recommends_info, recommends_index)"
            style="display: inline-block; padding: 5px"
          >
            <b-badge
              v-bind:href="recommends_info.recommend_url"
              variant="info"
              target="_blank"
              @click="gaClickEvents(recommends_info)"
              >{{ recommends_info.recommend_key }}</b-badge
            >
          </div>
        </div>
      </div>
      <div class="promotion" @click="goPromotionUrl(images[random].url)">
        <img v-bind:src="images[random].image" />
      </div>
    </div>
    <loading
      loader="bars"
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="true"
    ></loading>
  </div>
</template>
<style type="text/css"></style>
<script>
import VueLoading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  name: 'orderdonev2',
  components: {
    loading: VueLoading,
  },
  data: function () {
    return {
      apiUrl: '',
      isLoading: false,
      userId: '',
      userImage: '',
      userName: '',
      recommends: [],
      random: 0,
      images: [
        {
          title: '1',
          image: '@assets/ad/ezbuy3.jpg',
          url: 'https://chatxbuy.pse.is/79v9sr',
        },
      ],
    }
  },
  watch: {},
  methods: {
    clearShoppingCart: function () {
      const vm = this
      vm.$store.prodInfos = []
      localStorage.setItem('newprodInfos', JSON.stringify([]))
      vm.$forceUpdate()
    },
    getRecommends: function () {
      const vm = this
      vm.recommends = JSON.parse(localStorage.getItem('recommendInfo')).concat()
    },
    gaClickEvents: function (recommendsInfo) {
      const vm = this
      vm.$ga.event(
        'useFeatures',
        'clickButton',
        recommendsInfo.recommend_key,
        1
      )
    },
  },
  mounted() {
    const vm = this
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
    vm.random = Math.floor(Math.random() * vm.images.length)
    vm.clearShoppingCart()
    vm.getRecommends()
  },
}
</script>
